import { render, staticRenderFns } from "./FolderCosmoformItem.vue?vue&type=template&id=561dded6&scoped=true"
import script from "./FolderCosmoformItem.vue?vue&type=script&lang=js"
export * from "./FolderCosmoformItem.vue?vue&type=script&lang=js"
import style0 from "./FolderCosmoformItem.vue?vue&type=style&index=0&id=561dded6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561dded6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
